import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import { useDictionary } from '../../../common/contexts/DictionaryContext';
import { findHolidayBlockViolation } from '../../../common/utils/holidayBookingBlock';
import { formattedDate, formattedTime } from '../../../common/utils/date';
import { findLang } from '../../../common/models/lang';

// Informational only: the backend already removes Airport Shuttle and Shared
// Individualtransfer from the package list; this tells the customer why.
const HolidayBlockHint = ({ transfer }) => {
    const { t, i18n } = useTranslation();
    const dictionary = useDictionary();
    const langCode = findLang(i18n.language).code;

    const violation = findHolidayBlockViolation(transfer, dictionary?.holidayBookingBlocks);
    if (!violation) {
        return null;
    }

    return (
        <Alert severity="info" sx={{ mb: 1, ml: { xs: 0, sm: 5.25 } }}>
            {t(`holidayBlock.${violation.bound}`, {
                date: formattedDate(violation.date, langCode),
                time: formattedTime(violation.time, langCode),
            })}
        </Alert>
    );
};

export { HolidayBlockHint };
